import React from 'react';

import ProgressIndicator from '../../ProgressIndicator';

import './style.scss';

const dayNames = [
  'Zondag',
  'Maandag',
  'Dinsdag',
  'Woensdag',
  'Donderdag',
  'Vrijdag',
  'Zaterdag',
];

const Popup = (props) => {
  const { project } = props;
  const iconClass = `icon-${project.getIn(['project_type_name', 0], 'marker').toLowerCase()}`;
  const dateStart = new Date(project.getIn(['field_activity_datetime', 0]) * 1000);
  const dateEnd = new Date(project.getIn(['end_value', 0]) * 1000);
  const progress = (parseFloat(project.getIn(['field_max_volunteers', 0])) - parseFloat(project.getIn(['places_available', 0]))) / parseFloat(project.getIn(['field_max_volunteers', 0]));

  return (
    <article className="Popup">
      <div className="row">
        <div className="col-12 col-md-3">
          <i className={`icon icon-project-default ${iconClass} icon--large`} />
        </div>
        <div className="col-12 col-md-9">
          <h2>
            <a href={project.getIn(['url', 0])} rel="bookmark" className="block">{project.get('title', 0)}</a>
          </h2>
          <div className="Popup__date">
            <div>
              <span className="Popup__date__day">
                {dayNames[dateStart.getDay()]}
                &nbsp;
                {dateStart.getDate()}-{(dateStart.getMonth() + 1).toString().padStart(2, '0')}-{dateStart.getFullYear()}
                ,
              </span>
              <span className="Popup__date__time">
                &nbsp;
                {dateStart.getHours().toString().padStart(2, '0')}:{dateStart.getMinutes().toString().padStart(2, '0')}
                &nbsp;-&nbsp;
                {dateEnd.getHours().toString().padStart(2, '0')}:{dateEnd.getMinutes().toString().padStart(2, '0')}
              </span>
            </div>
          </div>
          <div className="Popup__location">{project.getIn(['address_line1', 0])}, {project.getIn(['locality', 0])}</div>

          <div className="Popup__actions">
            <div>
              <a href={project.getIn(['url', 0])} rel="bookmark" className="block">Bekijk project</a>
            </div>
            <div>
              <a className={`Button Button--primary ${project.getIn(['field_project_full', 0]) ? 'disabled' : ''} hidden-xs`} href={`${project.getIn(['url', 0])}#block-projectsubscribe`}>Meld je aan</a>
              <div className="Popup__status">
                <ProgressIndicator progress={progress} />
                <div className="Popup__availability">
                  { project.getIn(['field_project_full', 0]) === true
                    ? <span>Dit project is vol</span>
                    : <span>{project.getIn(['places_available', 0])} van {project.getIn(['field_max_volunteers', 0])} beschikbaar</span> }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default Popup;
